export default __webpack_public_path__ + "static/media/yeah-bro.82c040ab.gif";